import { useTranslation } from "../../i18n/useTranslation";
import styles from './fixcenter-career-job-offers.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';

const CareerRevitDesignerJobOffer: React.FC = () => {
    const { t } = useTranslation('translation');
    const getTranslate = (code: string) => {
        return t('CAREER_ITEMS.' + code);
    }
    return (
        <>
            <div className={styles.job_offers_container}>
                <div className={styles.content}>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_23')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_24')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_25')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_26')}}
                        className={classNames(globalStyles.float_left_item, styles.h2)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_27')}}
                        className={classNames(globalStyles.float_left_item, styles.h2)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_28')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_30')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_31')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_32')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_33')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_34')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_35')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_29')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_36')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_37')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_38')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_39')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_40')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_41')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_30')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_42')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_43')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_44')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_45')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_46')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_31')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_47')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_48')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_32')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_49')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_50')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_51')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_52')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_53')}</span></li>
                    </ul>

                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_33')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_34')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_35')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_36')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                </div>
            </div>
        </>
    );
};

export default CareerRevitDesignerJobOffer;